import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withKeys as _withKeys, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "table-toolbar"
}
const _hoisted_2 = { class: "toolbar-right" }
const _hoisted_3 = { class: "column-selector-wrapper" }
const _hoisted_4 = { class: "selector-header" }
const _hoisted_5 = { class: "selector-content" }
const _hoisted_6 = {
  key: 0,
  class: "no-columns-tip"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "table-header-filter" }
const _hoisted_9 = { class: "header-row" }
const _hoisted_10 = { class: "header-title" }
const _hoisted_11 = { class: "header-controls" }
const _hoisted_12 = { class: "sort-controls" }
const _hoisted_13 = { class: "sort-icons-container" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 0,
  class: "filter-controls"
}
const _hoisted_18 = { class: "filter-option-content" }
const _hoisted_19 = { class: "filter-option-label" }
const _hoisted_20 = {
  key: 0,
  class: "filter-option-check"
}
const _hoisted_21 = { class: "filter-input-item" }
const _hoisted_22 = ["onKeydown"]
const _hoisted_23 = { class: "filter-buttons" }
const _hoisted_24 = ["onKeydown"]
const _hoisted_25 = { class: "filter-buttons" }
const _hoisted_26 = ["onKeydown"]
const _hoisted_27 = { class: "between-input-row" }
const _hoisted_28 = { class: "filter-buttons" }
const _hoisted_29 = ["onKeydown"]
const _hoisted_30 = { class: "filter-buttons" }
const _hoisted_31 = ["onKeydown"]
const _hoisted_32 = { class: "datetime-between-row" }
const _hoisted_33 = { class: "filter-buttons" }
const _hoisted_34 = {
  key: 1,
  class: "pagination-wrapper"
}

import { ref, computed, onMounted, onUnmounted, watch, nextTick } from 'vue'
import { ElMessage } from 'element-plus'
import { Filter, Setting, Download, CaretTop, CaretBottom, Edit, Delete, View } from '@element-plus/icons-vue'
  
  // 分页配置接口
  interface PaginationConfig {
    show?: boolean // 是否显示分页器
    page?: number // 当前页码
    pageSize?: number // 每页数量
    total?: number // 总数据量
    pageSizes?: number[] // 每页数量选项
    layout?: string // 分页器布局
    small?: boolean // 是否使用小尺寸分页器
  }

  // Props
  interface Props {
    data: any[]
    loading?: boolean
    showColumnSelector?: boolean
    showExport?: boolean
    showDetailButton?: boolean
    showEditButton?: boolean
    showDeleteButton?: boolean
    operationNoWrap?: boolean
    showSelection?: boolean
    defaultSelection?: any[] // 预设选中的行数据
    model?: Record<string, string> // 接口返回的model字段，键为字段名，值为类型字符串（如 "String", "DateTime", "Int64" 等）
    columnLabels?: Record<string, string> // 表头字段中文映射
    columnWidths?: Record<string, number> // 自定义列宽映射，键为字段名，值为宽度(px)
    columnOrder?: string[] // 自定义列排序，优先显示的字段名数组
    hiddenColumns?: string[] // 页面级需要隐藏的字段
    maxHeight?: number // 表格最大高度
    activeRowKey?: string | number | null
    // 分页配置对象
    pagination?: PaginationConfig
  }
  
  
export default /*@__PURE__*/_defineComponent({
  __name: 'DynamicTable',
  props: {
    data: {},
    loading: { type: Boolean, default: false },
    showColumnSelector: { type: Boolean, default: true },
    showExport: { type: Boolean, default: true },
    showDetailButton: { type: Boolean, default: false },
    showEditButton: { type: Boolean, default: false },
    showDeleteButton: { type: Boolean, default: false },
    operationNoWrap: { type: Boolean, default: false },
    showSelection: { type: Boolean, default: false },
    defaultSelection: { default: () => [] },
    model: { default: undefined },
    columnLabels: { default: undefined },
    columnWidths: { default: undefined },
    columnOrder: { default: undefined },
    hiddenColumns: { default: () => [] },
    maxHeight: { default: undefined },
    activeRowKey: { default: null },
    pagination: { default: () => ({
      show: false,
      page: 1,
      pageSize: 10,
      total: 0,
      pageSizes: [10, 20, 50, 100],
      layout: 'total, sizes, prev, pager, next, jumper',
      small: true
    }) }
  },
  emits: ["detail", "edit", "delete", "sort", "filter", "selection-change", "page-change", "page-size-change"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

  // 定义事件
  const emit = __emit
  
  // 计算操作列宽度
  const getOperationColumnWidth = () => {
    let buttonCount = 0
    if (props.showEditButton) buttonCount++
    if (props.showDeleteButton) buttonCount++
    if (props.showDetailButton && !props.showEditButton && !props.showDeleteButton) buttonCount++
    // 每个图标按钮约40px，详情按钮约60px，加上间距
    if (props.showDetailButton && !props.showEditButton && !props.showDeleteButton) {
      // 有自定义插槽时需要更宽
      return 200
    }
    // 有自定义插槽时增加宽度
    return Math.max(200, buttonCount * 40 + (buttonCount - 1) * 8 + 100)
  }
    // 处理选择变化
   const handleSelectionChange = (selection: any[]) => {
    // 如果正在设置默认选中项，跳过事件触发，防止无限循环
    if (isSettingDefaultSelection.value) return
    
    // 保存当前选择状态
    currentSelection.value = [...selection]
    
    emit('selection-change', selection)
  }
  // 编辑按钮点击事件
  const handleEdit = (row: any) => {
    emit('edit', row)
  }
  
  // 删除按钮点击事件
  const handleDelete = (row: any) => {
    emit('delete', row)
  }

  // 分页事件处理
  const handlePageChange = (page: number) => {
    currentPage.value = page
    emit('page-change', page)
  }

  const handlePageSizeChange = (pageSize: number) => {
    currentPageSize.value = pageSize
    currentPage.value = 1 // 改变页大小时重置到第一页
    emit('page-size-change', pageSize)
  }

  const getRowClassName = ({ row }: { row: any }) => {
    if (props.activeRowKey === null || props.activeRowKey === undefined || props.activeRowKey === '') return ''
    const rowKey = row?.Id ?? row?.id
    return String(rowKey ?? '') === String(props.activeRowKey) ? 'dynamic-table-active-row' : ''
  }
  
// 响应式数据
const tableRef = ref<any>(null)
const isSettingDefaultSelection = ref(false) // 防止无限循环的标志
const activeFilters = ref<Map<string, any>>(new Map())
const columnFilters = ref<Map<string, any>>(new Map())

// 排序状态
const sortState = ref<{column: string, type: number} | null>(null)

// 分页相关响应式数据
const currentPage = ref(props.pagination?.page || 1)
const currentPageSize = ref(props.pagination?.pageSize || 10)

// 选择状态保持
const currentSelection = ref<any[]>([]) // 保存当前选择的项目

// 列筛选器相关
const showColumnSelector = ref(false)
const showColumnSelectorPopup = ref(false)
const visibleColumns = ref<string[]>([])
const allColumns = ref<Array<{key: string, label: string, width?: number, minWidth?: number}>>([])
const tableColumns = ref<Array<{prop: string, label: string, width?: number, minWidth?: number}>>([])
const filterConfig = ref<any[]>([])

const systemFieldNames = ['Id', 'ISDELETED', 'id',"检测数据格式描述"]
const hiddenColumnNames = computed(() => new Set((props.hiddenColumns || []).map((name) => String(name).toLowerCase())))

const shouldIncludeField = (key: string, modelType?: string, sampleValue?: any) => {
  const lowerKey = key.toLowerCase()

  if (hiddenColumnNames.value.has(lowerKey)) return false
  if (systemFieldNames.some(name => name.toLowerCase() === lowerKey)) return false
  if (lowerKey.includes('id')) return false
  if (lowerKey.includes('json')) return false
  if (lowerKey.includes('isdeleted')) return false

  if (modelType) {
    const typeLower = modelType.toLowerCase()
    if (
      typeLower.includes('list') ||
      typeLower.includes('[]') ||
      typeLower.includes('dictionary') ||
      typeLower.includes('map') ||
      typeLower.includes('collection')
    ) {
      return false
    }
  } else if (sampleValue !== undefined) {
    if (Array.isArray(sampleValue)) return false
    if (sampleValue && typeof sampleValue === 'object' && !(sampleValue instanceof Date)) return false
  }

  return true
}

// 生成表格列配置
const generateTableColumns = (data: any[] = []) => {
  const firstItem = data[0] || {}
  const columns: Array<{prop: string, label: string, width?: number, minWidth?: number}> = []
  const allColumnsData: Array<{key: string, label: string, width?: number, minWidth?: number}> = []
  const fields: Array<{ key: string, modelType?: string }> = []

  if (props.model && typeof props.model === 'object') {
    for (const key of Object.keys(props.model)) {
      const modelType = props.model[key]
      const sampleValue = firstItem ? firstItem[key] : undefined
      if (shouldIncludeField(key, modelType, sampleValue)) {
        fields.push({ key, modelType })
      }
    }
  } else {
    for (const key of Object.keys(firstItem || {})) {
      const sampleValue = firstItem[key]
      if (shouldIncludeField(key, undefined, sampleValue)) {
        fields.push({ key })
      }
    }
  }

  const fieldKeys = fields.map(field => field.key)

  if (fieldKeys.length === 0) {
    return
  }

  // 如果指定了 columnOrder，按指定顺序排列字段（未指定的字段排在后面）
  if (props.columnOrder && props.columnOrder.length > 0) {
    const orderMap = new Map(props.columnOrder.map((key, idx) => [key, idx]))
    fields.sort((a, b) => {
      const orderA = orderMap.has(a.key) ? orderMap.get(a.key)! : Number.MAX_SAFE_INTEGER
      const orderB = orderMap.has(b.key) ? orderMap.get(b.key)! : Number.MAX_SAFE_INTEGER
      return orderA - orderB
    })
  }

  for (let i = 0; i < fields.length; i++) {
    const { key, modelType } = fields[i]
    const isLastColumn = i === fields.length - 1
    const fieldType = modelType || null
    
    // 根据字段名和类型判断宽度
    let width = undefined // 不设置固定宽度，让列自适应
    let label = props.columnLabels?.[key] || key
    const labelLength = [...String(label)].length
    const computedMinWidth = Math.max(120, labelLength * 18)

    // 根据字段类型或字段名判断宽度
    if (fieldType) {
      const typeLower = fieldType.toLowerCase()
      if (typeLower.includes('datetime') || typeLower.includes('date') || typeLower.includes('time')) {
        width = 180
      } else if (typeLower.includes('int64') || typeLower.includes('int32') || typeLower.includes('int')) {
        width = 120
      } else if (typeLower.includes('boolean')) {
        width = 100
        if (key.includes('ISDELETED') || key.includes('IsDeleted') || key.includes('isDeleted')) {
          label = '是否删除'
        }
      } else if (key.length > 10) {
        width = 200 // 长字段名给更宽的空间
      }
    } else {
      // 如果没有model，使用原来的逻辑
      if (key.includes('时间') || key.includes('Time') || key.includes('Date')) {
        width = 180
      } else if (key.includes('id') || key.includes('Id') || key.includes('ID')) {
        width = 120
      } else if (key.includes('ISDELETED') || key.includes('IsDeleted') || key.includes('isDeleted')) {
        width = 100
        label = '是否删除'
      } else if (key.length > 10) {
        width = 200 // 长字段名给更宽的空间
      }
    }
    
    // 确保列宽度至少能展示表头文本
    if (width && width < computedMinWidth) {
      width = computedMinWidth
    }

    // 自定义列宽覆盖自动计算的宽度
    if (props.columnWidths && props.columnWidths[key]) {
      width = props.columnWidths[key]
    }
    
    // 最后一列不设置固定宽度，让它自适应填充剩余空间
    if (isLastColumn) {
      width = undefined
    }
    
    // 为 DynamicTable 生成列配置（使用 prop）
    columns.push({
      prop: key,
      label: label,
      width: width,
      minWidth: computedMinWidth
    })
    
    // 为列选择器生成配置（使用 key）
    allColumnsData.push({
      key: key,
      label: label,
      width: width,
      minWidth: computedMinWidth
    })
  }
  
  allColumns.value = allColumnsData
  tableColumns.value = columns
  
  // 默认全选所有列
  visibleColumns.value = allColumnsData.map(col => col.key)
  
  // 生成筛选配置
  generateFilterConfig()
}

// 将model中的类型字符串转换为筛选配置使用的类型
const convertModelTypeToFilterType = (modelType: string): string => {
  if (!modelType) return 'string'
  
  const typeLower = modelType.toLowerCase()
  
  // 处理可空类型（如 "Boolean?"）
  const baseType = typeLower.replace('?', '').trim()
  
  if (baseType.includes('datetime') || baseType.includes('date') || baseType.includes('time')) {
    return 'datetime'
  } else if (baseType.includes('int64') || baseType.includes('long')) {
    return 'int64'
  } else if (baseType.includes('int32') || baseType.includes('int')) {
    return 'int32'
  } else if (baseType.includes('boolean') || baseType.includes('bool')) {
    return 'boolean'
  } else if (baseType.includes('string') || baseType.includes('str')) {
    return 'string'
  } else if (baseType.includes('number') || baseType.includes('decimal') || baseType.includes('double') || baseType.includes('float')) {
    return 'int64' // 数值类型统一使用int64
  } else {
    return 'string' // 默认返回string
  }
}

// 生成筛选配置
const generateFilterConfig = () => {
  const config = []

  // 优先从model中获取字段和类型
  if (props.model && typeof props.model === 'object') {
    // 从model对象中获取所有字段
    for (const key in props.model) {
      const modelType = props.model[key]
      const sampleValue = props.data && props.data.length > 0 ? props.data[0][key] : undefined
      if (shouldIncludeField(key, modelType, sampleValue)) {
        const fieldType = convertModelTypeToFilterType(modelType)
        
        config.push({
          FieldName: key,
          FiedType: fieldType,
          Type: 3, // 数据过滤
          Value1: '',
          Value2: ''
        })
      }
    }
  } else if (props.data && props.data.length > 0) {
    // 如果没有model，从数据中推断类型（保持向后兼容）
    const firstItem = props.data[0]
    for (const key in firstItem) {
      const value = firstItem[key]
      if (shouldIncludeField(key, undefined, value)) {
        let fieldType = ''
        
        // 根据字段名和值判断类型
        if (key.includes('时间') || key.includes('Time') || key.includes('Date')) {
          fieldType = 'datetime'
        } else if (key.includes('id') || key.includes('Id') || key.includes('ID')) {
          fieldType = 'int64'
        } else if (key.includes('ISDELETED') || key.includes('IsDeleted') || key.includes('isDeleted')) {
          fieldType = 'boolean'
        } else if (typeof value === 'boolean') {
          fieldType = 'boolean'
        } else if (typeof value === 'number') {
          fieldType = value >= -2147483648 && value <= 2147483647 ? 'int32' : 'int64'
        } else if (value instanceof Date || /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(value)) {
          fieldType = 'datetime'
        } else {
          fieldType = 'string'
        }
        
        config.push({
          FieldName: key,
          FiedType: fieldType,
          Type: 3, // 数据过滤
          Value1: '',
          Value2: ''
        })
      }
    }
  }
  
  filterConfig.value = config
}

// 监听数据变化和model变化，自动生成列配置
watch([() => props.data, () => props.model, () => props.hiddenColumns], ([newData, newModel]) => {
  const hasData = Array.isArray(newData) && newData.length > 0
  const hasModel = newModel && typeof newModel === 'object' && Object.keys(newModel).length > 0
  if (hasData || hasModel) {
    generateTableColumns(hasData ? newData : [])
  }
}, { immediate: true })

// 监听数据和预设选中项变化，设置表格选中状态
watch([() => props.data, () => props.defaultSelection], ([newData, newDefaultSelection]) => {
  if (tableRef.value && Array.isArray(newData) && Array.isArray(newDefaultSelection) && newDefaultSelection.length > 0) {
    // 使用 nextTick 确保表格已经渲染完成
    nextTick(() => {
      setDefaultSelection(newData, newDefaultSelection)
    })
  }
}, { immediate: true })

// 设置预设选中项
const setDefaultSelection = (data: any[], defaultSelection: any[]) => {
  if (!tableRef.value || !Array.isArray(data) || !Array.isArray(defaultSelection)) return
  
  // 设置标志，防止触发selection-change事件
  isSettingDefaultSelection.value = true
  
  try {
    // 清空当前选中项
    tableRef.value.clearSelection()
    
    // 根据ID匹配并设置选中项
    defaultSelection.forEach(selectedItem => {
      const selectedId = selectedItem.Id || selectedItem.id
      if (selectedId) {
        const matchedRow = data.find(row => {
          const rowId = row.Id || row.id
          return rowId === selectedId
        })
        if (matchedRow) {
          tableRef.value.toggleRowSelection(matchedRow, true)
        }
      }
    })
  } finally {
    // 重置标志
    isSettingDefaultSelection.value = false
  }
}
  
  // 计算属性 - 直接使用props.data，筛选由后端处理
  const filteredData = computed(() => {
    return props.data
  })
  
  // 获取字段的筛选配置
  const getFilterConfig = (columnProp: string) => {
    return filterConfig.value.find(config => config.FieldName === columnProp)
  }
  
  // 获取筛选选项
  const getFilterOptions = (columnProp: string) => {
    const config = getFilterConfig(columnProp)
    if (!config || config.Type !== 3) return []
    
    const fieldType = config.FiedType || getDataType(columnProp)
    const options = []
    
    switch (fieldType.toLowerCase()) {
      case 'string':
        options.push(
          { label: '包含', value: 'contains' },
          { label: '不包含', value: 'not_contains' },
          { label: '等于', value: 'equals' }
        )
        break
      case 'int32':
      case 'int64':
      case 'int':
      case 'number':
        options.push(
          { label: '等于', value: 'equals' },
          { label: '大于', value: 'greater' },
          { label: '小于', value: 'less' },
          { label: '介于', value: 'between' }
        )
        break
      case 'date':
      case 'datetime':
      case 'time':
        options.push(
          { label: '等于', value: 'equals' },
          { label: '大于', value: 'greater' },
          { label: '小于', value: 'less' },
          { label: '介于', value: 'between' }
        )
        break
      case 'boolean':
        options.push(
          { label: 'True', value: 'true' },
          { label: 'False', value: 'false' }
        )
        break
    }
    
    return options
  }
  
  // 判断数据类型
  const getDataType = (columnProp: string) => {
    const sampleData = props.data[0]
    if (!sampleData || !sampleData[columnProp]) return 'string'
    
    const value = sampleData[columnProp]
    
    if (typeof value === 'boolean') return 'boolean'
    if (typeof value === 'number') return 'number'
    if (value instanceof Date || /^\d{4}-\d{2}-\d{2}/.test(value)) return 'date'
    return 'string'
  }
  
  // 获取字段类型
  const getFieldType = (columnProp: string) => {
    const config = getFilterConfig(columnProp)
    return config?.FiedType || getDataType(columnProp)
  }
  
  // 获取活跃筛选类型
  const getActiveFilterType = (columnProp: string) => {
    return columnFilters.value.get(columnProp)?.type || ''
  }
  
  // 获取筛选值
  const getFilterValue = (columnProp: string, key: string) => {
    return columnFilters.value.get(columnProp)?.[key] || ''
  }

  
  // 设置筛选类型
  const setFilterType = (columnProp: string, filterType: string) => {
    if (!columnFilters.value.has(columnProp)) {
      columnFilters.value.set(columnProp, { type: '', value1: '', value2: '' })
    }
    const filter = columnFilters.value.get(columnProp)
    if (filter) {
      filter.type = filterType
      // 不清空已输入的值，保持用户输入的内容
    }
  }
  
  // 设置筛选值
  const setFilterValue = (columnProp: string, key: string, value: any) => {
    if (!columnFilters.value.has(columnProp)) {
      columnFilters.value.set(columnProp, { type: '', value1: '', value2: '' })
    }
    const filter = columnFilters.value.get(columnProp)
    if (filter) {
      filter[key] = value
      // 只保存输入值，不自动应用筛选
    }
  }

  // 确认筛选
  const confirmFilter = (columnProp: string) => {
    const filter = columnFilters.value.get(columnProp)
    
    if (!filter || !filter.type) {
      ElMessage.warning('请先选择筛选条件')
      return
    }
    
    if (!filter.value1) {
      ElMessage.warning('请输入筛选值')
      return
    }
    
    // 将列筛选添加到活动筛选
    activeFilters.value.set(columnProp, {
      type: filter.type,
      value1: filter.value1,
      value2: filter.value2
    })
    
    // 构建筛选参数并触发事件（不包含排序）
    const filterParams = buildFilterOnlyParams()
    
    // 触发筛选事件，同时传递当前选择状态用于恢复
    emit('filter', filterParams, currentSelection.value)
    
    // 根据筛选类型显示不同的提示信息
    let message = ''
    switch (filter.type) {
      case 'contains':
        message = `已应用筛选: 包含 "${filter.value1}"`
        break
      case 'not_contains':
        message = `已应用筛选: 不包含 "${filter.value1}"`
        break
      case 'equals':
        message = `已应用筛选: 等于 "${filter.value1}"`
        break
      case 'greater':
        message = `已应用筛选: 大于 "${filter.value1}"`
        break
      case 'less':
        message = `已应用筛选: 小于 "${filter.value1}"`
        break
      case 'between':
        message = `已应用筛选: 介于 "${filter.value1}" 到 "${filter.value2}"`
        break
      case 'true':
        message = `已应用筛选: 为 True`
        break
      case 'false':
        message = `已应用筛选: 为 False`
        break
      default:
        message = `已应用筛选: ${filter.type} - ${filter.value1}`
    }
    
    ElMessage.success(message)
  }
  
  // 重置筛选
  const resetFilter = (columnProp: string) => {
    // 清空输入值
    if (columnFilters.value.has(columnProp)) {
      const filter = columnFilters.value.get(columnProp)
      if (filter) {
        filter.value1 = ''
        filter.value2 = ''
      }
    }
    
    // 移除活动筛选
    activeFilters.value.delete(columnProp)
    
    // 构建筛选参数并触发事件（不包含排序）
    const filterParams = buildFilterOnlyParams()
    emit('filter', filterParams)
    
    ElMessage.success('筛选条件已重置')
  }
  
// 处理筛选
const handleFilter = (columnProp: string, command: string, event?: Event) => {
  if (command.startsWith('filter_')) {
    // 修复解析逻辑：从 command 中提取筛选类型
    // command 格式: filter_${columnProp}_${filterType}
    const prefix = `filter_${columnProp}_`
    const filterType = command.replace(prefix, '')
    
    // 对于布尔类型，直接应用筛选
    if (getFieldType(columnProp) === 'boolean' && (filterType === 'true' || filterType === 'false')) {
      // 直接应用布尔筛选
      activeFilters.value.set(columnProp, {
        type: filterType,
        value1: filterType,
        value2: ''
      })
      
      // 显示筛选提示
      ElMessage.success(`已应用筛选: ${filterType === 'true' ? '为 True' : '为 False'}`)
    } else {
      setFilterType(columnProp, filterType)
      // 不再自动应用筛选，等待用户点击确定按钮
    }
  }
}

  
  
  
  // 应用筛选到单个数据项
  const applyFilterToItem = (item: any, column: string, filter: any) => {
    const value = item[column]
    if (value === null || value === undefined) return false
    
    let result = false
    switch (filter.type) {
      case 'contains':
        result = String(value).includes(filter.value1)
        break
      case 'not_contains':
        result = !String(value).includes(filter.value1)
        break
      case 'equals':
        result = String(value) === filter.value1
        break
      case 'greater':
        // 对于DateTime类型，比较时间戳
        if (filter.value1 && (typeof value === 'string' || value instanceof Date)) {
          const valueTime = new Date(value).getTime()
          const filterTime = new Date(filter.value1).getTime()
          result = valueTime > filterTime
        } else {
          result = Number(value) > Number(filter.value1)
        }
        break
      case 'less':
        // 对于DateTime类型，比较时间戳
        if (filter.value1 && (typeof value === 'string' || value instanceof Date)) {
          const valueTime = new Date(value).getTime()
          const filterTime = new Date(filter.value1).getTime()
          result = valueTime < filterTime
        } else {
          result = Number(value) < Number(filter.value1)
        }
        break
      case 'between':
        // 对于DateTime类型，比较时间戳范围
        if (filter.value1 && filter.value2 && (typeof value === 'string' || value instanceof Date)) {
          const valueTime = new Date(value).getTime()
          const startTime = new Date(filter.value1).getTime()
          const endTime = new Date(filter.value2).getTime()
          result = valueTime >= startTime && valueTime <= endTime
        } else {
          result = Number(value) >= Number(filter.value1) && Number(value) <= Number(filter.value2)
        }
        break
      case 'true':
        result = Boolean(value) === true
        break
      case 'false':
        result = Boolean(value) === false
        break
      default:
        result = true
    }
    
    return result
  }
  
  // 列筛选器相关方法
  const toggleColumnSelector = () => {
    showColumnSelectorPopup.value = !showColumnSelectorPopup.value
  }

  const toggleColumn = (columnKey: string) => {
    if (columnKey === '编码') return // 编码列不能取消选择
    
    const index = visibleColumns.value.indexOf(columnKey)
    if (index > -1) {
      visibleColumns.value.splice(index, 1)
    } else {
      visibleColumns.value.push(columnKey)
    }
  }

  const selectAllColumns = () => {
    visibleColumns.value = allColumns.value.map(col => col.key)
    ElMessage.success('已选择所有列')
  }

  // 点击外部关闭列选择器
  const handleClickOutside = (event: MouseEvent) => {
    const target = event.target as HTMLElement
    const selectorWrapper = document.querySelector('.column-selector-wrapper')
    if (selectorWrapper && !selectorWrapper.contains(target)) {
      showColumnSelectorPopup.value = false
    }
  }

  // 计算可见的列
  const visibleTableColumns = computed(() => {
    if (visibleColumns.value.length === 0) {
      return tableColumns.value
    }
    return tableColumns.value.filter((col: any) => visibleColumns.value.includes(col.prop))
  })

  // 生命周期钩子
  onMounted(() => {
    // 添加点击外部关闭事件
    document.addEventListener('click', handleClickOutside)
  })

  onUnmounted(() => {
    // 移除事件监听
    document.removeEventListener('click', handleClickOutside)
  })

  // 格式化时间显示
  const formatDateTime = (dateTimeStr: string) => {
    if (!dateTimeStr || dateTimeStr === '0001-01-01 00:00:00') {
      return '-'
    }
    try {
      const date = new Date(dateTimeStr)
      if (isNaN(date.getTime())) {
        return '-'
      }
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
    } catch (error) {
      return '-'
    }
  }

  // 导出CSV功能
  const exportToCSV = async () => {
    if (filteredData.value.length === 0) {
      ElMessage.warning('没有数据可导出')
      return
    }

    const [xlsxModule, fileSaverModule] = await Promise.all([
      import('xlsx'),
      import('file-saver')
    ])

    const XLSX = xlsxModule.default || xlsxModule
    const saveAs = fileSaverModule.saveAs || fileSaverModule.default?.saveAs || fileSaverModule.default
    if (typeof saveAs !== 'function') {
      throw new Error('file-saver 加载失败')
    }

    // 根据可见列动态构建CSV数据
    const csvData = filteredData.value.map(item => {
      const row: any = {}
      
      for (const column of allColumns.value) {
        if (visibleColumns.value.includes(column.key)) {
          if (column.key.includes('ISDELETED') || column.key.includes('IsDeleted') || column.key.includes('isDeleted')) {
            row[column.label] = item[column.key] ? '是' : '否'
          } else if (column.key.includes('时间') || column.key.includes('Time') || column.key.includes('Date')) {
            row[column.label] = formatDateTime(item[column.key])
          } else {
            row[column.label] = item[column.key] || '-'
          }
        }
      }
      
      return row
    })

    // 转换为CSV
    const ws = XLSX.utils.json_to_sheet(csvData)
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, '数据列表')
    
    // 导出文件
    const wbout = XLSX.write(wb, { bookType: 'csv', type: 'array' })
    const blob = new Blob([wbout], { type: 'application/octet-stream' })
    saveAs(blob, `数据列表_${new Date().toISOString().slice(0, 10)}.csv`)
    
    ElMessage.success(`CSV文件导出成功，共 ${filteredData.value.length} 条数据，包含 ${visibleColumns.value.length} 列`)
  }

  // 排序处理函数
  const handleSort = (column: string, type: number) => {
    // 如果点击的是当前已激活的同类型排序，则取消排序
    if (sortState.value && sortState.value.column === column && sortState.value.type === type) {
      // 取消排序
      sortState.value = null;
      // 触发一个特殊的排序事件，表示取消排序
      emit('sort', column, 0); // 0 表示取消排序
    } else {
      // 设置新的排序状态
      sortState.value = { column, type };
      emit('sort', column, type);
    }
    
    // 构建包含排序和筛选的完整参数并触发事件
    const allParams = buildFilterParams();
    emit('filter', allParams, currentSelection.value);
  }

  // 获取排序状态
  const getSortState = (column: string) => {
    if (sortState.value && sortState.value.column === column) {
      return sortState.value.type;
    }
    return null; // 未排序状态
  }

  // 构建排序参数
   const buildSortParams = () => {
    const filters = []
    
    // 添加排序参数
    if (sortState.value) {
      filters.push({
        FieldName: sortState.value.column,
        FiedType: getFieldType(sortState.value.column),
        Type: sortState.value.type, // 1:升序, 2:降序
        Value1: '',
        Value2: ''
      })
    }
    
    return filters
  }

  // 构建筛选参数（不包含排序）
  const buildFilterOnlyParams = () => {
    const filters = []
    
    // 只添加筛选参数
    for (const [column, filter] of activeFilters.value) {
      const fieldType = getFieldType(column)
      let type = 3 // 数据过滤
      let value1 = ''
      let value2 = ''
      
      // 根据筛选类型设置参数
      switch (filter.type) {
        case 'contains':
          // 字符串：包含 Value1 = 条件值 Value2=""
          value1 = filter.value1
          value2 = ''
          break
        case 'not_contains':
          // 字符串：不包含 Value2 = 条件值 Value1=""
          value1 = ''
          value2 = filter.value1
          break
        case 'equals':
          // 字符串、时间、数值：等于 Value1 = 条件值 Value2 = ""
          value1 = filter.value1
          value2 = ''
          break
        case 'greater':
          // 时间、数值：大于 Value1 = 条件值 Value2=""
          value1 = filter.value1
          value2 = ''
          break
        case 'less':
          // 时间、数值：小于 Value2 = 条件值 Value1=""
          value1 = ''
          value2 = filter.value1
          break
        case 'between':
          // 时间、数值：介于 Value1 = 小值 Value2=大值
          value1 = filter.value1
          value2 = filter.value2
          break
        case 'true':
          // 布尔：value1等于"true"代表true
          value1 = 'true'
          value2 = ''
          break
        case 'false':
          // 布尔：value1等于"false"代表false
          value1 = 'false'
          value2 = ''
          break
      }
      
      filters.push({
        FieldName: column,
        FiedType: fieldType,
        Type: type,
        Value1: value1,
        Value2: value2
      })
    }
    
    return filters
  }

  // 构建筛选参数（包含排序和筛选）
 const buildFilterParams = () => {
    const filters = []
    
    // 添加排序参数
    if (sortState.value) {
      filters.push({
        FieldName: sortState.value.column,
        FiedType: getFieldType(sortState.value.column),
        Type: sortState.value.type, // 1:升序, 2:降序
        Value1: '',
        Value2: ''
      })
    }
    
    // 添加筛选参数
    for (const [column, filter] of activeFilters.value) {
      const fieldType = getFieldType(column)
      let type = 3 // 数据过滤
      let value1 = ''
      let value2 = ''
      
      // 根据筛选类型设置参数
      switch (filter.type) {
        case 'contains':
          // 字符串：包含 Value1 = 条件值 Value2=""
          value1 = filter.value1
          value2 = ''
          break
        case 'not_contains':
          // 字符串：不包含 Value2 = 条件值 Value1=""
          value1 = ''
          value2 = filter.value1
          break
        case 'equals':
          // 字符串、时间、数值：等于 Value1 = 条件值 Value2 = ""
          value1 = filter.value1
          value2 = ''
          break
        case 'greater':
          // 时间、数值：大于 Value1 = 条件值 Value2=""
          value1 = filter.value1
          value2 = ''
          break
        case 'less':
          // 时间、数值：小于 Value2 = 条件值 Value1=""
          value1 = ''
          value2 = filter.value1
          break
        case 'between':
          // 时间、数值：介于 Value1 = 小值 Value2=大值
          value1 = filter.value1
          value2 = filter.value2
          break
        case 'true':
          // 布尔：value1等于"true"代表true
          value1 = 'true'
          value2 = ''
          break
        case 'false':
          // 布尔：value1等于"false"代表false
          value1 = 'false'
          value2 = ''
          break
      }
      
      filters.push({
        FieldName: column,
        FiedType: fieldType,
        Type: type,
        Value1: value1,
        Value2: value2
      })
    }
    
    return filters
  }

  // 详情按钮点击事件
  const handleDetail = (row: any) => {
    emit('detail', row)
  }

  // 格式化单元格值，处理布尔值转换
  const formatCellValue = (value: any, columnProp: string) => {
    // 如果值是布尔类型，进行转换
    if (typeof value === 'boolean') {
      return value ? '是' : '否'
    }
    
    // 如果值是字符串形式的布尔值，也进行转换
    if (typeof value === 'string') {
      const lowerValue = value.toLowerCase()
      if (lowerValue === 'true') {
        return '是'
      } else if (lowerValue === 'false') {
        return '否'
      }
    }
    
    // 其他类型的值直接返回
    return value
  }

  // 监听 props 变化，同步分页状态
  watch(() => props.pagination?.page, (newPage) => {
    if (newPage !== undefined) {
      currentPage.value = newPage
    }
  })

  watch(() => props.pagination?.pageSize, (newPageSize) => {
    if (newPageSize !== undefined) {
      currentPageSize.value = newPageSize
    }
  })

  // 恢复选择状态的方法
  const restoreSelection = async (savedSelection: any[]) => {
    if (!tableRef.value || !Array.isArray(savedSelection) || savedSelection.length === 0) {
      return;
    }
    
    await nextTick()
    
    // 设置标志，防止触发selection-change事件
    isSettingDefaultSelection.value = true
    
    try {
      // 清除当前选择
      tableRef.value.clearSelection()
      
      // 恢复之前的选择
      savedSelection.forEach((item: any) => {
        const foundRow = props.data.find((row: any) => {
          const rowId = row.Id || row.id
          const itemId = item.Id || item.id
          return rowId && itemId && String(rowId) === String(itemId)
        })
        
        if (foundRow) {
          tableRef.value.toggleRowSelection(foundRow, true)
        }
      })
      
      // 更新当前选择状态
      currentSelection.value = [...savedSelection]
    } finally {
      // 重置标志
      setTimeout(() => {
        isSettingDefaultSelection.value = false
      }, 100)
    }
  }

  // 暴露方法给父组件
  __expose({
    clearAllFilters: () => {
      activeFilters.value.clear()
      columnFilters.value.clear()
      ElMessage.success('所有筛选条件已清除')
    },
    getActiveFilters: () => activeFilters.value,
    toggleColumnSelector,
    toggleColumn,
    selectAllColumns,
    visibleColumns: visibleColumns.value,
    exportToCSV,
    restoreSelection
  })
  
return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_card = _resolveComponent("el-card")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_card, {
    class: "dynamic-table-card",
    shadow: "hover"
  }, {
    default: _withCtx(() => [
      (showColumnSelector.value || _ctx.showExport)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "toolbar-left" }, null, -1)),
            _createElementVNode("div", _hoisted_2, [
              (_ctx.showExport)
                ? (_openBlock(), _createBlock(_component_el_tooltip, {
                    key: 0,
                    content: "导出CSV",
                    placement: "top"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        icon: _unref(Download),
                        circle: "",
                        size: "small",
                        onClick: exportToCSV
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_el_tooltip, {
                  content: "列选择器",
                  placement: "top"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      icon: _unref(Setting),
                      circle: "",
                      size: "small",
                      onClick: toggleColumnSelector,
                      readonly: allColumns.value.length === 0
                    }, null, 8, ["icon", "readonly"])
                  ]),
                  _: 1
                }),
                _withDirectives(_createElementVNode("div", {
                  class: "custom-column-selector",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _createElementVNode("div", _hoisted_4, [
                    _cache[18] || (_cache[18] = _createElementVNode("span", null, "选择要显示的列", -1)),
                    (allColumns.value.length > 0)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "text",
                          size: "small",
                          onClick: selectAllColumns
                        }, {
                          default: _withCtx(() => _cache[17] || (_cache[17] = [
                            _createTextVNode(" 全选 ")
                          ])),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    (allColumns.value.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, " 暂无列数据 "))
                      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(allColumns.value, (column) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: column.key,
                            class: "column-item",
                            onClick: ($event: any) => (toggleColumn(column.key))
                          }, [
                            _createVNode(_component_el_checkbox, {
                              value: column.key,
                              readonly: column.key === '编码',
                              "model-value": visibleColumns.value.includes(column.key),
                              onChange: ($event: any) => (toggleColumn(column.key))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(column.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["value", "readonly", "model-value", "onChange"])
                          ], 8, _hoisted_7))
                        }), 128))
                  ])
                ], 512), [
                  [_vShow, showColumnSelectorPopup.value]
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        ref_key: "tableRef",
        ref: tableRef,
        data: filteredData.value,
        border: "",
        stripe: "",
        style: {"width":"100%"},
        "max-height": _ctx.maxHeight,
        "row-class-name": getRowClassName,
        onSelectionChange: handleSelectionChange
      }, {
        default: _withCtx(() => [
          (_ctx.showSelection)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                type: "selection",
                width: "55"
              }))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleTableColumns.value, (column) => {
            return (_openBlock(), _createBlock(_component_el_table_column, {
              key: column.prop,
              prop: column.prop,
              label: column.label,
              width: column.width,
              "min-width": column.minWidth,
              sortable: false,
              "show-overflow-tooltip": true
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(formatCellValue(row[column.prop], column.prop)), 1)
              ]),
              header: _withCtx(({ column: col }) => [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(col.label), 1),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_el_tooltip, {
                          content: "排序",
                          placement: "top"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["sort-icon sort-icon-up", { 'active': getSortState(col.property) === 1 }]),
                                onClick: ($event: any) => (handleSort(col.property, 1))
                              }, [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(CaretTop))
                                  ]),
                                  _: 1
                                })
                              ], 10, _hoisted_14),
                              _createElementVNode("div", {
                                class: _normalizeClass(["sort-icon sort-icon-down", { 'active': getSortState(col.property) === 2 }]),
                                onClick: ($event: any) => (handleSort(col.property, 2))
                              }, [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(CaretBottom))
                                  ]),
                                  _: 1
                                })
                              ], 10, _hoisted_15)
                            ])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      (getFilterConfig(col.property))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            (getFilterConfig(col.property)?.Type === 3)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                  _createVNode(_component_el_dropdown, {
                                    onCommand: (command, event) => handleFilter(col.property, command, event),
                                    trigger: "click",
                                    placement: "bottom",
                                    "hide-on-click": false
                                  }, {
                                    dropdown: _withCtx(() => [
                                      _createVNode(_component_el_dropdown_menu, null, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getFilterOptions(col.property), (option) => {
                                            return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                              key: option.value,
                                              command: `filter_${col.property}_${option.value}`,
                                              class: _normalizeClass({ 'filter-option-selected': getActiveFilterType(col.property) === option.value })
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("span", _hoisted_18, [
                                                  _createElementVNode("span", _hoisted_19, _toDisplayString(option.label), 1),
                                                  (getActiveFilterType(col.property) === option.value)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, "✓"))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ]),
                                              _: 2
                                            }, 1032, ["command", "class"]))
                                          }), 128)),
                                          (getFilterConfig(col.property)?.Type === 3)
                                            ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                                key: 0,
                                                command: `input_${col.property}`,
                                                divided: ""
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("div", _hoisted_21, [
                                                    (getFieldType(col.property) === 'string' && getActiveFilterType(col.property) !== 'between')
                                                      ? (_openBlock(), _createElementBlock("div", {
                                                          key: 0,
                                                          class: "input-with-buttons",
                                                          onKeydown: _withKeys(_withModifiers(($event: any) => (confirmFilter(col.property)), ["stop","prevent"]), ["enter"])
                                                        }, [
                                                          _createVNode(_component_el_input, {
                                                            "model-value": getFilterValue(col.property, 'value1'),
                                                            "onUpdate:modelValue": (value) => setFilterValue(col.property, 'value1', value),
                                                            placeholder: "输入筛选内容",
                                                            size: "small",
                                                            onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                                                            style: {"width":"100px"}
                                                          }, null, 8, ["model-value", "onUpdate:modelValue"]),
                                                          _createElementVNode("div", _hoisted_23, [
                                                            _createVNode(_component_el_button, {
                                                              size: "small",
                                                              type: "primary",
                                                              onClick: [
                                                                ($event: any) => (confirmFilter(col.property)),
                                                                _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                                                              ]
                                                            }, {
                                                              default: _withCtx(() => _cache[20] || (_cache[20] = [
                                                                _createTextVNode(" 确定 ")
                                                              ])),
                                                              _: 2
                                                            }, 1032, ["onClick"]),
                                                            _createVNode(_component_el_button, {
                                                              size: "small",
                                                              onClick: [
                                                                ($event: any) => (resetFilter(col.property)),
                                                                _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                                                              ]
                                                            }, {
                                                              default: _withCtx(() => _cache[21] || (_cache[21] = [
                                                                _createTextVNode(" 重置 ")
                                                              ])),
                                                              _: 2
                                                            }, 1032, ["onClick"])
                                                          ])
                                                        ], 40, _hoisted_22))
                                                      : ((getFieldType(col.property) === 'int32' || getFieldType(col.property) === 'int64' || getFieldType(col.property) === 'int' || getFieldType(col.property) === 'number') && getActiveFilterType(col.property) !== 'between')
                                                        ? (_openBlock(), _createElementBlock("div", {
                                                            key: 1,
                                                            class: "input-with-buttons",
                                                            onKeydown: _withKeys(_withModifiers(($event: any) => (confirmFilter(col.property)), ["stop","prevent"]), ["enter"])
                                                          }, [
                                                            _createVNode(_component_el_input, {
                                                              "model-value": getFilterValue(col.property, 'value1'),
                                                              "onUpdate:modelValue": (value) => setFilterValue(col.property, 'value1', value),
                                                              placeholder: "输入数值",
                                                              size: "small",
                                                              type: "number",
                                                              onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
                                                              style: {"width":"100px"}
                                                            }, null, 8, ["model-value", "onUpdate:modelValue"]),
                                                            _createElementVNode("div", _hoisted_25, [
                                                              _createVNode(_component_el_button, {
                                                                size: "small",
                                                                type: "primary",
                                                                onClick: [
                                                                  ($event: any) => (confirmFilter(col.property)),
                                                                  _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                                                                ]
                                                              }, {
                                                                default: _withCtx(() => _cache[22] || (_cache[22] = [
                                                                  _createTextVNode(" 确定 ")
                                                                ])),
                                                                _: 2
                                                              }, 1032, ["onClick"]),
                                                              _createVNode(_component_el_button, {
                                                                size: "small",
                                                                onClick: [
                                                                  ($event: any) => (resetFilter(col.property)),
                                                                  _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
                                                                ]
                                                              }, {
                                                                default: _withCtx(() => _cache[23] || (_cache[23] = [
                                                                  _createTextVNode(" 重置 ")
                                                                ])),
                                                                _: 2
                                                              }, 1032, ["onClick"])
                                                            ])
                                                          ], 40, _hoisted_24))
                                                        : _createCommentVNode("", true),
                                                    (getActiveFilterType(col.property) === 'between' && getFieldType(col.property) !== 'datetime')
                                                      ? (_openBlock(), _createElementBlock("div", {
                                                          key: 2,
                                                          class: "between-inputs",
                                                          onKeydown: _withKeys(_withModifiers(($event: any) => (confirmFilter(col.property)), ["stop","prevent"]), ["enter"])
                                                        }, [
                                                          _createElementVNode("div", _hoisted_27, [
                                                            _createVNode(_component_el_input, {
                                                              "model-value": getFilterValue(col.property, 'value1'),
                                                              "onUpdate:modelValue": (value) => setFilterValue(col.property, 'value1', value),
                                                              placeholder: "最小值",
                                                              size: "small",
                                                              type: "number",
                                                              onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"])),
                                                              style: {"width":"70px"}
                                                            }, null, 8, ["model-value", "onUpdate:modelValue"]),
                                                            _cache[24] || (_cache[24] = _createElementVNode("span", { class: "between-separator" }, "~", -1)),
                                                            _createVNode(_component_el_input, {
                                                              "model-value": getFilterValue(col.property, 'value2'),
                                                              "onUpdate:modelValue": (value) => setFilterValue(col.property, 'value2', value),
                                                              placeholder: "最大值",
                                                              size: "small",
                                                              type: "number",
                                                              onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"])),
                                                              style: {"width":"70px"}
                                                            }, null, 8, ["model-value", "onUpdate:modelValue"])
                                                          ]),
                                                          _createElementVNode("div", _hoisted_28, [
                                                            _createVNode(_component_el_button, {
                                                              size: "small",
                                                              type: "primary",
                                                              onClick: [
                                                                ($event: any) => (confirmFilter(col.property)),
                                                                _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
                                                              ]
                                                            }, {
                                                              default: _withCtx(() => _cache[25] || (_cache[25] = [
                                                                _createTextVNode(" 确定 ")
                                                              ])),
                                                              _: 2
                                                            }, 1032, ["onClick"]),
                                                            _createVNode(_component_el_button, {
                                                              size: "small",
                                                              onClick: [
                                                                ($event: any) => (resetFilter(col.property)),
                                                                _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"]))
                                                              ]
                                                            }, {
                                                              default: _withCtx(() => _cache[26] || (_cache[26] = [
                                                                _createTextVNode(" 重置 ")
                                                              ])),
                                                              _: 2
                                                            }, 1032, ["onClick"])
                                                          ])
                                                        ], 40, _hoisted_26))
                                                      : (getFieldType(col.property) === 'datetime' && getActiveFilterType(col.property) !== 'between')
                                                        ? (_openBlock(), _createElementBlock("div", {
                                                            key: 3,
                                                            class: "datetime-inputs",
                                                            onKeydown: _withKeys(_withModifiers(($event: any) => (confirmFilter(col.property)), ["stop","prevent"]), ["enter"])
                                                          }, [
                                                            _createVNode(_component_el_date_picker, {
                                                              "model-value": getFilterValue(col.property, 'value1'),
                                                              "onUpdate:modelValue": (value) => setFilterValue(col.property, 'value1', value),
                                                              type: "datetime",
                                                              placeholder: "选择日期时间",
                                                              size: "small",
                                                              style: {"width":"180px"},
                                                              format: "YYYY-MM-DD HH:mm:ss",
                                                              "value-format": "YYYY-MM-DD HH:mm:ss"
                                                            }, null, 8, ["model-value", "onUpdate:modelValue"]),
                                                            _createElementVNode("div", _hoisted_30, [
                                                              _createVNode(_component_el_button, {
                                                                size: "small",
                                                                type: "primary",
                                                                onClick: [
                                                                  ($event: any) => (confirmFilter(col.property)),
                                                                  _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"]))
                                                                ]
                                                              }, {
                                                                default: _withCtx(() => _cache[27] || (_cache[27] = [
                                                                  _createTextVNode(" 确定 ")
                                                                ])),
                                                                _: 2
                                                              }, 1032, ["onClick"]),
                                                              _createVNode(_component_el_button, {
                                                                size: "small",
                                                                onClick: [
                                                                  ($event: any) => (resetFilter(col.property)),
                                                                  _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"]))
                                                                ]
                                                              }, {
                                                                default: _withCtx(() => _cache[28] || (_cache[28] = [
                                                                  _createTextVNode(" 重置 ")
                                                                ])),
                                                                _: 2
                                                              }, 1032, ["onClick"])
                                                            ])
                                                          ], 40, _hoisted_29))
                                                        : (getFieldType(col.property) === 'datetime' && getActiveFilterType(col.property) === 'between')
                                                          ? (_openBlock(), _createElementBlock("div", {
                                                              key: 4,
                                                              class: "datetime-between-inputs",
                                                              onKeydown: _withKeys(_withModifiers(($event: any) => (confirmFilter(col.property)), ["stop","prevent"]), ["enter"])
                                                            }, [
                                                              _createElementVNode("div", _hoisted_32, [
                                                                _createVNode(_component_el_date_picker, {
                                                                  "model-value": getFilterValue(col.property, 'value1'),
                                                                  "onUpdate:modelValue": (value) => setFilterValue(col.property, 'value1', value),
                                                                  type: "datetime",
                                                                  placeholder: "开始时间",
                                                                  size: "small",
                                                                  style: {"width":"150px"},
                                                                  format: "YYYY-MM-DD HH:mm:ss",
                                                                  "value-format": "YYYY-MM-DD HH:mm:ss"
                                                                }, null, 8, ["model-value", "onUpdate:modelValue"]),
                                                                _cache[29] || (_cache[29] = _createElementVNode("span", { class: "between-separator" }, "~", -1)),
                                                                _createVNode(_component_el_date_picker, {
                                                                  "model-value": getFilterValue(col.property, 'value2'),
                                                                  "onUpdate:modelValue": (value) => setFilterValue(col.property, 'value2', value),
                                                                  type: "datetime",
                                                                  placeholder: "结束时间",
                                                                  size: "small",
                                                                  style: {"width":"150px"},
                                                                  format: "YYYY-MM-DD HH:mm:ss",
                                                                  "value-format": "YYYY-MM-DD HH:mm:ss"
                                                                }, null, 8, ["model-value", "onUpdate:modelValue"])
                                                              ]),
                                                              _createElementVNode("div", _hoisted_33, [
                                                                _createVNode(_component_el_button, {
                                                                  size: "small",
                                                                  type: "primary",
                                                                  onClick: [
                                                                    ($event: any) => (confirmFilter(col.property)),
                                                                    _cache[13] || (_cache[13] = _withModifiers(() => {}, ["stop"]))
                                                                  ]
                                                                }, {
                                                                  default: _withCtx(() => _cache[30] || (_cache[30] = [
                                                                    _createTextVNode(" 确定 ")
                                                                  ])),
                                                                  _: 2
                                                                }, 1032, ["onClick"]),
                                                                _createVNode(_component_el_button, {
                                                                  size: "small",
                                                                  onClick: [
                                                                    ($event: any) => (resetFilter(col.property)),
                                                                    _cache[14] || (_cache[14] = _withModifiers(() => {}, ["stop"]))
                                                                  ]
                                                                }, {
                                                                  default: _withCtx(() => _cache[31] || (_cache[31] = [
                                                                    _createTextVNode(" 重置 ")
                                                                  ])),
                                                                  _: 2
                                                                }, 1032, ["onClick"])
                                                              ])
                                                            ], 40, _hoisted_31))
                                                          : _createCommentVNode("", true)
                                                  ])
                                                ]),
                                                _: 2
                                              }, 1032, ["command"]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_button, {
                                        type: "primary",
                                        size: "small",
                                        icon: _unref(Filter),
                                        circle: "",
                                        class: "filter-btn",
                                        onClick: _withModifiers(($event: any) => (!getActiveFilterType(col.property) && getFilterOptions(col.property).length ? setFilterType(col.property, getFilterOptions(col.property)[0].value) : undefined), ["stop"])
                                      }, null, 8, ["icon", "onClick"])
                                    ]),
                                    _: 2
                                  }, 1032, ["onCommand"])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              _: 2
            }, 1032, ["prop", "label", "width", "min-width"]))
          }), 128)),
          (_ctx.showDetailButton || _ctx.showEditButton || _ctx.showDeleteButton || _ctx.$slots.action)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 1,
                label: "操作",
                width: getOperationColumnWidth(),
                fixed: "right",
                align: "center"
              }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("div", {
                    style: _normalizeStyle([{"display":"flex","gap":"8px","justify-content":"center","align-items":"center"}, { flexWrap: _ctx.operationNoWrap ? 'nowrap' : 'wrap', whiteSpace: _ctx.operationNoWrap ? 'nowrap' : 'normal' }])
                  }, [
                    (_ctx.showEditButton)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "primary",
                          size: "small",
                          icon: _unref(View),
                          plain: "",
                          onClick: ($event: any) => (handleEdit(row))
                        }, null, 8, ["icon", "onClick"]))
                      : _createCommentVNode("", true),
                    (_ctx.showDeleteButton)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 1,
                          type: "danger",
                          size: "small",
                          icon: _unref(Delete),
                          plain: "",
                          onClick: ($event: any) => (handleDelete(row))
                        }, null, 8, ["icon", "onClick"]))
                      : _createCommentVNode("", true),
                    (_ctx.showDetailButton && !_ctx.showEditButton && !_ctx.showDeleteButton)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 2,
                          type: "primary",
                          size: "small",
                          onClick: ($event: any) => (handleDetail(row))
                        }, {
                          default: _withCtx(() => _cache[32] || (_cache[32] = [
                            _createTextVNode(" 详情 ")
                          ])),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true),
                    _renderSlot(_ctx.$slots, "action", { row: row })
                  ], 4)
                ]),
                _: 3
              }, 8, ["width"]))
            : _createCommentVNode("", true)
        ]),
        _: 3
      }, 8, ["data", "max-height"])), [
        [_directive_loading, _ctx.loading]
      ]),
      (_ctx.pagination?.show)
        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
            _createVNode(_component_el_pagination, {
              "current-page": currentPage.value,
              "onUpdate:currentPage": _cache[15] || (_cache[15] = ($event: any) => ((currentPage).value = $event)),
              "page-size": currentPageSize.value,
              "onUpdate:pageSize": _cache[16] || (_cache[16] = ($event: any) => ((currentPageSize).value = $event)),
              "page-sizes": _ctx.pagination?.pageSizes || [10, 20, 50, 100],
              total: _ctx.pagination?.total || 0,
              layout: _ctx.pagination?.layout || 'total, sizes, prev, pager, next, jumper',
              size: _ctx.pagination?.small !== false ? 'small' : 'default',
              onSizeChange: handlePageSizeChange,
              onCurrentChange: handlePageChange
            }, null, 8, ["current-page", "page-size", "page-sizes", "total", "layout", "size"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}
}

})